import ModalImage from "./components/Modal/ModalImage";
import NavCtxProvider from "./context/NavState";
import DialogContextProvider from "./context/DialogState";
import MainMenu from "./components/MainMenu";
import FirstPage from "./components/Firstpage";
import SpecialCalcLink from "./components/SpecialCalcLink";
import FeedbackButton from "./components/Pulse/PulseButton";
import Services from "./components/Services/Services";
import Slider from "./components/Slider/Slider";
import Pipeline from "./components/Pipeline";
import Calculator from "./components/Calc/Calculator";
import Map from "./components/Map";
import Footer from "./components/Footer";
import React, { useState } from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { getSuccess } from "./redux/Main_reducer";
import Modal from "./components/Modal/Modal";

const MainPage = ({ pageSuccess }) => {
  const [modalImage, setModalImage] = useState(null);
  const [modal, setModal] = useState(null);
  return pageSuccess ? (
    <Redirect to="/success" />
  ) : (
    <>
      {modalImage && (
        <ModalImage active={modalImage} setActive={setModalImage}>
          {modalImage}
        </ModalImage>
      )}
      <NavCtxProvider>
        <DialogContextProvider>
          <MainMenu />
        </DialogContextProvider>
        <FirstPage />
        <SpecialCalcLink />
        <FeedbackButton />
        <Services />
        <Slider setModalImage={setModalImage} />
        <Pipeline />
        <Calculator setModal={setModal} />
        {modal && (
          <Modal active={modal} setActive={setModal}>
            {modal}
          </Modal>
        )}
        <Map />
        <Footer />
      </NavCtxProvider>
    </>
  );
};
export default connect((state) => ({
  pageSuccess: getSuccess(state),
}))(MainPage);
